import 'webp-in-css/polyfill';

import './lib/icons';
import './lib/lazyload';

import './services/rgpd-cookies';

import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';

import tooltip from './plugins/tooltip';
import fitIframe from './plugins/fit-iframe';
import display from './plugins/display';
import datalayer from './plugins/datalayer';
import keep from './plugins/keep';

import homepage from './pages/homepage';
import product from './pages/product';
import rolex from './pages/rolex';
import './pages/checkout-cart';
import './pages/common';

import account from './components/account';
import accountSidebar from './components/accountSidebar';
import goodiesSidebar from './components/goodiesSidebar';
import cart from './components/cart';
import dropdown from './components/dropdown';
import facets from './components/facets';
import header from './components/header';

import modals from './components/modals';

import range from './components/range';
import slider from './components/slider';
import store from './components/store';
import video from './components/video';
import vimeo from './components/vimeo';
import countdown from './components/countdown';
import storeMap from './components/store-map';

import adminstoresfields from './modules/adminstoresfields';
import algolia from './modules/algolia';
import customization from './modules/customization';
import fractomenu from './modules/fractomenu';
import itroom_ringsize from './modules/itroom_ringsize';
import itroom_accessories from './modules/itroom_accessories';
import itroom_printmaking from './modules/itroom_printmaking';
import itroom_personnalisation from './modules/itroom_personnalisation';
import prestablog from './modules/prestablog';
import ps_emailsubscription from './modules/ps_emailsubscription';
import whisper from './modules/whisper';
import ps_shoppingcart from './modules/ps_shoppingcart';
import contact_form from './modules/contact_form';
import './modules/ga_datalayer';
import './modules/dynamic-data';

import { createApp } from './utils/alpine';

const modules = {
    adminstoresfields,
    algolia,
    customization,
    fractomenu,
    itroom_ringsize,
    itroom_accessories,
    itroom_personnalisation,
    itroom_printmaking,
    prestablog,
    ps_emailsubscription,
    ps_shoppingcart,
    whisper,
    contact_form
};

const components = {
    account,
    accountSidebar,
    goodiesSidebar,
    cart,
    dropdown,
    facets,
    homepage,
    modals,
    product,
    range,
    slider,
    store,
    video,
    vimeo,
    header,
    countdown,
    storeMap,
};

const pages = {
    rolex,
};

createApp({
    modules,
    components,
    pages,
}, [
    intersect,
    persist,
    tooltip,
    display,
    datalayer,
    fitIframe,
    keep,
], {
    display: {
        hidePrices: false,
        showFeatures: false,
    },
});
